import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import enLang from '../../i18n/en.json'
import ruLang from '../../i18n/ru.json'

const resources = {
  ru: {
    translation: ruLang,
  },
  en: {
    translation: enLang,
  },
}

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: 'ru',
  lng: 'ru',

  interpolation: {
    escapeValue: false,
  },
})

export default i18n
